import typeSms from '@/kit/types/summary-sms'
import typeEmail from '@/kit/types/summary-email'

export default (scope, params) => {
  return scope.channel.id === 1
    ? typeSms(scope, params)
    : typeEmail(scope, params)
}
